<div class="container py-3">
  <!-- 1. Card dei Filtri -->
  <div class="card">
    <div class="card-header">
      <div class="title-3">Invio dati in piattaforma flussi</div>
    </div>
    <div class="card-body" style="background-color: #fff">
      <form [formGroup]="filtriForm">
        <div class="group-inline">
          <!-- Filtro ANNO -->
          <div class="form-group field-8">
            <label style="font-weight: bold">Anno:</label>
            <select class="form-control" formControlName="anno" name="anno">
              <option *ngFor="let year of yearArray" value="{{ year }}">
                {{ year }}
              </option>
            </select>
          </div>
          <!-- Filtro ASL -->
          <div class="groupo-inline">
            <div class="col-3 form-group">
              <label style="font-weight: bold">Asl: </label>
              <select class="form-control" formControlName="asl" name="asl">
                <option value="">Seleziona Asl</option>
                <option *ngFor="let asl of aslList" value="{{ asl.codiceAzienda }}">
                  {{ asl.denominazioneAzienda }}
                </option>
              </select>
            </div>
          </div>
          <!-- Filtro AMBITO -->
          <div class="form-group field-16">
            <label style="font-weight: bold">Ambito:</label>
            <select class="form-control" formControlName="siglaFlusso" name="siglaFlusso">
              <option value="">Seleziona Ambito</option>
              <option *ngFor="let amb of ambitiList" [value]="amb.codiceFlusso">
                {{ amb.ambito }}
              </option>
            </select>
          </div>
          <!-- Filtro PERIODO -->
          <div class="form-group field-16">
            <label style="font-weight: bold">Periodo:</label>
            <select class="form-control" formControlName="periodo" name="periodo" tabindex="-98">
              <option value="">Seleziona Periodo</option>
              <option *ngFor="let etichetta of etichette | keyvalue: compareEtichette" value="{{ etichetta.key }}">
                {{ etichetta.value }}
              </option>
            </select>
          </div>
        </div>
      </form>
    </div>
    
    <!-- Footer con i bottoni Pulisci e Cerca -->
    <div class="card-footer">
      <div class="btn-toolbar">
        <div class="btn-group-left">
          <button class="btn btn-outline-secondary" type="button" (click)="pulisciFiltri()">
            Pulisci
          </button>
        </div>
        <div class="btn-group-center"></div>
        <div class="btn-group-right">
          <button class="btn btn-secondary" type="button" (click)="cerca()">
            Cerca
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- 2. Card della Tabella Storico -->
  <div class="card mt-5">
    <div class="card-body">
      
      <!-- Intestazione Tabella con Bottone Genera Invio -->
      <div class="d-flex justify-content-between align-items-center" style="margin-bottom: 10px">
        <div class="title-4 m-0">
          Storico Invii
        </div>
        <button class="btn btn-primary" (click)="apriWizardInvio()">GENERA INVIO</button>
      </div>

      <div class="table-responsive">
        <div class="list-table table-even">
          <table class="table table-lg">
            <thead>
              <tr>
                <th>Data creazione</th>
                <th>Sigla</th>
                <th>Anno</th>
                <th>Asl</th>
                <th>Ambito</th>
                <th>Periodo</th>
                <th>Trasmesso Da</th>
                <th>Esito Trasmissione</th>
                <th>Messaggio Trasmissione</th>
                <th>Nr Invio</th>
                <th>Stato Invio</th>
                <th>File</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let flusso of paginaStorico.content">
                <td class="td-hover" data-label="Data">{{flusso.createdOn | date:'d/M/y HH:mm'}}</td>
                <td class="td-hover" data-label="Flusso">{{flusso.siglaFlusso}}</td>
                <td class="td-hover" data-label="Anno">{{flusso.anno}}</td>
                <td class="td-hover" data-label="Asl">{{printAslName(flusso.asl)}}</td>
                <td class="td-hover" data-label="Ambito">{{flusso.ambito}}</td>
                <td class="td-hover" data-label="Periodo">{{etichette[flusso.periodo ? flusso.periodo : 0]}}</td>
                <td class="td-hover" data-label="Trasmesso da">{{flusso.createdBy}}</td>
                <td class="td-hover" data-label="Esito Trasmissione">{{flusso.esitoTrasmissione ? 'Successo' : 'Fallimento'}}</td>
                <td class="td-hover col-messaggio-trasmissione" data-label="Messaggio Trasmissione">{{flusso.msgTrasmissione}}</td>
                <td class="td-hover" data-label="Id Invio">{{flusso.idIstanzaInvio}}</td>
                <td class="td-hover" data-label="Stato Invio">
                  <button *ngIf="flusso.esitoTrasmissione" container="body" class="btn btn-icon-solo btn-sm small" ngbTooltip="Visualizza lo stato dell'invio" placement="top" (click)="apriDettaglioInvio(flusso.idIstanzaInvio)">
                    <svg class="s-icon icon-sm text-info" style="width: 25px; height: 25px; padding: 0">
                      <use href="#info-square"></use>
                    </svg>
                  </button>
                  <button *ngIf="!flusso.esitoTrasmissione" container="body" class="btn btn-icon-solo btn-sm small" ngbTooltip="Trasmissione fallita" placement="top" style="cursor: default;">
                    <svg class="s-icon icon-sm text-danger icon-status" style="width: 25px; height: 25px; padding: 0">
                    <use href="#warning-triangle"></use>
                    </svg>
                  </button>
                </td>
                <td class="td-hover" data-label="File" style="min-width: 180px; text-align: center;">
                  <div *ngIf="getFilesArchiviati(flusso)?.length > 0" class="btn-group m-1">
                    <button class="btn btn-primary btn-sm">{{getFilesArchiviati(flusso)?.length}} FILE</button>
                    <button type="button" class="btn btn-primary btn-sm dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown" aria-expanded="false">
                      <span class="visually-hidden">Toggle Dropdown</span>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end">
                      <li *ngFor="let fileName of getFilesArchiviati(flusso)">
                        <a class="dropdown-item" href="javascript:void(0)" (click)="downloadSingleFile(flusso.id, fileName)">{{fileName}}</a>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
              <tr *ngIf="paginaStorico.content && paginaStorico.content.length === 0">
                <td colspan="10" class="text-center py-4">Nessun invio trovato per i filtri selezionati.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="d-flex justify-content-between pt-3">
        <app-paginator
          [page]="paginaStorico"
          (cambiaPaginaEvent)="cambiaPagina($event)"
        ></app-paginator>
      </div>

    </div>
  </div>
</div>

<!-- Modale Dettaglio Stato Invio -->
<ng-template #dettaglioInvioModal let-modal>
  <div class="modal-header bg-primary text-white">
    <h4 class="modal-title">Dettaglio Stato Invio</h4>
    <a class="close text-white" aria-label="Close" (click)="modal.dismiss('Cross click')" style="cursor: pointer;">
      <svg class="s-icon icon-sm"><use href="#close"></use></svg>
    </a>
  </div>
  <div class="modal-body text-center py-5" *ngIf="isLoadingDettaglio">
    <div class="spinner-border text-primary" role="status"></div>
    <p class="mt-3">Recupero informazioni in corso...</p>
  </div>
  <div class="modal-body" *ngIf="!isLoadingDettaglio && dettaglioInvioCorrente">
    <div class="container-fluid">
      
      <div class="form-group mb-3">
        <label class="font-weight-bold" style="font-weight: 600;">ID Invio</label>
        <input type="text" class="form-control" [value]="dettaglioInvioCorrente.id_invio" readonly style="background-color: #f4f5f7;">
      </div>

      <div class="form-group mb-3">
        <label class="font-weight-bold" style="font-weight: 600;">Stato Invio</label>
        <input type="text" class="form-control"
                [value]="dettaglioInvioCorrente.descrizione_stato_invio.toUpperCase() || dettaglioInvioCorrente.codice_stato_invio.toUpperCase()"
                readonly style="background-color: #f4f5f7;">
      </div>

      <!-- Note -->
      <div class="form-group mb-3" *ngIf="dettaglioInvioCorrente.note">
        <label class="font-weight-bold" style="font-weight: 600;">Note</label>
        <textarea class="form-control" rows="2" readonly style="background-color: #f4f5f7; resize: none;">{{ dettaglioInvioCorrente.note }}</textarea>
      </div>

      <!-- Errore INBOUND o PIATTAFORMA -->
      <div class="form-group mb-3" *ngIf="dettaglioInvioCorrente.messaggio_errore">
        <label class="font-weight-bold text-danger" style="font-weight: 600;">Messaggio di Errore</label>
        <textarea class="form-control border-danger text-danger" rows="4" readonly style="background-color: #fdf5f5; resize: none;">{{ dettaglioInvioCorrente.messaggio_errore }}</textarea>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss('Close click')">Chiudi</button>
  </div>
</ng-template>